import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { finalize, Subject, takeUntil } from 'rxjs';
import {
  iEmployeeResult,
  iEmployeeResultDto,
} from 'src/app/helpers/Interfaces/employee';
import {
  iNotificationDto,
  iNotificationResponse,
} from 'src/app/helpers/Interfaces/notifications';
import { NotificationsService } from 'src/app/helpers/notifications.service';

@Component({
  selector: 'app-navbar-notification',
  templateUrl: './navbar-notification.component.html',
})
export class NavbarNotificationComponent implements OnInit, OnDestroy {
  notifications: iNotificationDto[] = [];
  notificationsLoading = false;
  markAllLoading = false;
  unreadCount = 0;
  private _employee: iEmployeeResultDto;
  private _unsubscribeAll = new Subject();
  constructor(
    private _notificationsServ: NotificationsService,
    private _toastrServ: ToastrService
  ) {
    this._employee = _notificationsServ._dataServ.employeeValue;
  }
  ngOnInit(): void {
    this._fetchNotifications();
  }
  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  markAsRead(id: string | string[]) {
    this.markAllLoading = true;
    const ids = Array.isArray(id) ? id : [id];
    this._notificationsServ
      .readNotification(ids)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: () => {
          this.markAllLoading = false;
        },
        error: (er) => {
          console.warn(er);
          this._toastrServ.error('Something went wrong.');
        },
      });
  }
  markAllAsRead() {
    this.markAsRead(
      this.notifications.filter((x) => !x.isReaded).map((x) => x.id)
    );
  }

  private _fetchNotifications() {
    this._notificationsServ.notifications$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((notifications) => {
        this.unreadCount = 0;
        this.notifications = notifications;

        notifications.forEach((notification) => {
          if (!notification.isReaded) this.unreadCount++;
        });
      });
    this._notificationsServ.notificationsLoading$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((loading) => {
        this.notificationsLoading = loading;
      });
  }
}
